import React, { useEffect, useState } from "react";
import { GoogleMap, useLoadScript } from "@react-google-maps/api";
import { Constant } from "../../constants";
import { Markers } from "./Markers";
import DefaultLoading from "../../components/common/DefaultLoading";

export interface Location {
  lat: number;
  lng: number;
}

interface Props {
  locations: Location[];
}

const mapContainerStyle = {
  width: "100%",
  height: "80vh",
  borderRadius: "1rem",
};
const mapOptions = {
  styles: [
    {
      featureType: "all",
      stylers: [
        { saturation: -70 },
        { lightness: 50 },
        { visibility: "simplified" },
      ],
    },
  ],
};

const Map: React.FC<Props> = ({ locations }) => {
  const [map, setMap] = useState<google.maps.Map>();
  const [displayLocations, setDisplayLocations] = useState<Location[]>([]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (map) {
        const bounds = new window.google.maps.LatLngBounds();
        locations.forEach((loc) => {
          bounds.extend(new google.maps.LatLng(loc.lat, loc.lng));
        });

        setDisplayLocations(locations);
        map.fitBounds(bounds);
      }
    }, 800);

    return () => clearTimeout(timeout);
  }, [map, locations]);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: Constant.GOOGLE_MAPS_KEY,
    libraries: Constant.GOOGLE_MAPS_LIBRARIES as [],
  });

  if (loadError)
    return <div className="mx-auto">Error loading maps{loadError.message}</div>;
  if (!isLoaded)
    return (
      <div className="flex items-center justify-center h-full">
        <DefaultLoading />
      </div>
    );

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      zoom={10}
      options={mapOptions}
      onLoad={(map) => setMap(map)}
    >
      {map && <Markers markers={displayLocations} />}
    </GoogleMap>
  );
};

export default Map;
